<template>
  <q-avatar
    v-if="!fallback && imgUrl"
    :size="avatarSize"
    color="transparent"
  >
    <q-img
      :src="imgUrl"
      :alt="label"
      style="border-radius: 50%"
      :width="imgSize"
      :height="imgSize"
      @error="handleError"
    />
  </q-avatar>


  <q-avatar
    v-else
    :size="avatarSize"
  >
    <svg :style="svgStyle">
      <text
        x="50%"
        y="50%"
        text-anchor="middle"
        dominant-baseline="central"
        :style="textStyle"
      >
        {{ avatarLetter }}
      </text>
    </svg>
  </q-avatar>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    imgUrl: {
      type: String,
      default: ''
    },
    avatarSize: {
      type: String,
      default: '32px'
    },
    imgSize: {
      type: String,
      default: '16px'
    },
    rounded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fallback: false
    };
  },
  computed: {
    avatarLetter() {
      return this.label ? this.label.substring(0, 2).toUpperCase() : '?';
    },
    svgStyle() {
      const size = parseInt(this.avatarSize);
      const letterIndex = this.avatarLetter.charCodeAt() - 64;
      const hue = (360 / 26) * letterIndex;
      const backgroundColor = `hsl(${hue}, 68%, 48%)`;

      return {
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: this.rounded ? '100%' : '0',
        background: backgroundColor
      };
    },
    textStyle() {
      const size = parseInt(this.avatarSize);
      return {
        fill: 'rgba(255, 255, 255, .7)',
        fontFamily: "'Lucida Console', Monaco, monospace",
        fontSize: `${size * 0.55}px`
      };
    }
  },
  watch: {
    imgUrl(newUrl) {
      if (newUrl) {
        this.fallback = false;
      }
    }
  },
  methods: {
    handleError() {
      this.fallback = true;
    }
  }
};
</script>
